import { ApplicationBrokerConsentScreen } from "@/interactors/ApplicationBrokerConsentScreen";

export default function BrokerConsent() {
  return <ApplicationBrokerConsentScreen />;
}
